import {BUSINESS_COACH, BUSINESS_LEADER, COACH} from '/enum/competency.enum';

import * as gradient from '../color/gradient.color';
import * as primary from '../color/primary.color';

export default {
  [COACH]: {
    primaryDarker: primary.pineDarker,
    primaryDark: primary.pineDark,
    primary: primary.pine,
    primaryLight: primary.pineLight,
    primaryLighter: primary.pineLighter,
    primaryLightest: primary.pineLightest,
    gradient: gradient.pine,
  },
  [BUSINESS_COACH]: {
    primaryDarker: primary.kimberlyDarker,
    primaryDark: primary.kimberlyDark,
    primary: primary.kimberly,
    primaryLight: primary.kimberlyLight,
    primaryLighter: primary.kimberlyLighter,
    primaryLightest: primary.kimberlyLightest,
    gradient: gradient.java,
  },
  [BUSINESS_LEADER]: {
    primaryDarker: primary.blueDarker,
    primaryDark: primary.blueDark,
    primary: primary.blue,
    primaryLight: primary.blueLight,
    primaryLighter: primary.blueLighter,
    primaryLightest: primary.blueLightest,
    gradient: gradient.blue,
  },
};
